<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.unit_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <div class="d-flex flex-row">
            <span class="iconsminds-stop mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Units"/>

<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchUnit" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'List of Units'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

             <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                      :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                      :current-page="meta.current_page" :fields="table_fields" :items="fetchUnits">
                 <template v-slot:cell(id)="data">
                     <span v-text="data.item.data.attributes.code"/>
                 </template>

                 <template v-if="false" v-slot:cell(name)="data">
                     <span @click="unitDetails(data.item)" style="cursor: pointer;" class="text-data-link"
                                  v-text="data.item.data.attributes.name"/>
                 </template>

                 <template v-slot:cell(name)="data">
                     <span class="text-data-link" v-text="data.item.data.attributes.name"/>
                 </template>

                 <template v-slot:cell(floor)="data">
                     <span v-text="data.item.data.attributes.floor"/>
                 </template>

                 <template v-slot:cell(facility)="data">
                     <span v-text="data.item.data.attributes.facility"/>
                 </template>

                 <template v-slot:cell(type)="data">
                     <span v-text="data.item.data.attributes.type"/>
                 </template>

                 <template v-slot:cell(vacant_from)="data">
                     <span v-text="data.item.data.attributes.vacant_from"/>
                 </template>

                 <template v-slot:cell(active)="data">
                     <b-badge pill style="width: 58px;"
                              :variant="data.item.data.attributes.active === 'Active' ? 'info' : 'danger'">
                         {{ data.item.data.attributes.active }}
                     </b-badge>
                 </template>

                 <template v-slot:cell(vacant)="data">
                     <b-badge pill style="width: 65px;"
                              :variant="data.item.data.attributes.status === 'Vacant' ? 'light' : 'warning'">
                         {{ data.item.data.attributes.status }}
                     </b-badge>
                 </template>

                 <template v-slot:cell(actions)="data">
                     <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                 menu-class="mt-2" style="width: 75px;" right no-caret>

                         <template slot="button-content">
                             <i class="btn-circle simple-icon-options-vertical"/>
                         </template>

                         <b-dropdown-item v-if="false" @click="unitDetails(data.item)">
                             Details
                         </b-dropdown-item>

                         <b-dropdown-item @click="changeStatus(data.item)">
                             Change Status
                         </b-dropdown-item>

                         <b-dropdown-item @click="editUnit(data.item.unit_id)">
                             Edit
                         </b-dropdown-item>

                         <b-dropdown-item @click="deleteUnit(data.item)">
                             Delete
                         </b-dropdown-item>
                     </b-dropdown>
                 </template>
             </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <UnitFormModal :edit="edit" @updated="tableKey++"/>

        <UnitStatusModal v-if="unit" :unit="unit" :current-status="currentStatus" @updated="handleStatusUpdate" />

        <UnitDetailsModal v-if="unit" :unit="unit" />

        <UnitDeleteModal v-if="unit" :unit="unit" @updated="tableKey++"/>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import UnitFormModal from "./modals/UnitFormModal";
    import UnitStatusModal from "./modals/UnitStatusModal";
    import UnitDeleteModal from "./modals/UnitDeleteModal";
    import UnitDetailsModal from "./modals/UnitDetailsModal";

    export default {
        name: "UnitsList",

        components: {
            UnitFormModal,
            UnitStatusModal,
            UnitDetailsModal,
            UnitDeleteModal,
        },

        data() {
            return {
                loading: false,
                edit: false,
                tableKey: 0,
                unit: null,
                currentStatus: false,
            }
        },

        computed: {
            ...mapGetters({
                table_fields: 'getUnitTableFields',
                meta: 'getUnitsMeta',
            }),
        },

        methods: {
            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            searchUnit: _.debounce(function (event) {
                // if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                // }
            }, 300),

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            refreshData() {
                this.$store.commit('resetUnitsMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },

            fetchUnits() {
                return this.$store.dispatch('fetchUnits')
                    .then(units => {
                        return units.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            unitDetails(unit) {
                this.unit = unit;

                setTimeout(() => {
                    this.$bvModal.show('unit_details');
                }, 1);
            },

            editUnit(unit_id) {
                this.edit = true;

                this.$store.dispatch('fetchEditUnit', unit_id)
                    .finally(response => {
                        this.$bvModal.show('unit_form');
                    });
            },

            deleteUnit(unit) {
                this.unit = unit;

                setTimeout(() => {
                    this.$bvModal.show('unit_delete');
                }, 1);
            },

            async changeStatus(unit) {
                this.unit = unit;

                await this.$store.dispatch('fetchUnit', unit.unit_id);
                this.currentStatus = this.unit.data.attributes.active.toLowerCase() === 'active';

                setTimeout(() => {
                    this.$bvModal.show('unit_status');
                }, 1);
            },

            handleStatusUpdate(newStatus) {
                this.tableKey++
                this.currentStatus = newStatus;
            }
        }
    }
</script>

<style scoped>

</style>
